export const userAccountDg = `
<!-- USER SIGNIN DIALOG -->
<div class="screen-overlay">
	<div class="userAccountDialog dialog">
		<!-- Account area -->
		<!-- add shacc-hide class to hide account UI -->
		<!-- signInView, createAccountView, emailConfirmationView,
		finishAccountView, manageAccountView -->
		<div id="stscr-account">
			
			<!-- Loading Overlay - toggle on by adding class "show"-->
			<div class="ani-loadingOverlay shacc-hide">
				<div>
					<div class="ani-lo-pleaseWait">Please wait...</div>
					<div class="ani-lo-lds-default">
						<div></div><div></div><div></div><div></div><div></div><div></div>
						<div></div><div></div><div></div><div></div><div></div><div></div>
					</div>
				</div>
			</div>
			
			<!-- Sign In View -->
			<div id="act-signInView">
				<div id="siv-title" class="shacc-header">Sign In</div>
				<div id="siv-emailDiv">
					<input id="siv-emailInput" class="shacc" type="text" 
						placeholder="Email" />
				</div>
				<div id="siv-passwordDiv">
					<input id="siv-passwordInput" class="shacc" type="password" 
						placeholder="Password" />
				</div>
				<div id="siv-resetDiv">
					<a id="siv-resetLink" class="shacc">
						Trouble logging in? Reset your password.
					</a>
				</div>
				<div class="shacc-message">Name must begin with a letter and contain 
					only letters, numbers, apostrophes, hyphens or underscores.
				</div>
				<div id="siv-buttons" class="shacc-bottomButtonsSection">
					<div id="siv-signInBtnDiv">
						<button id="siv-signInBtn">Sign In</button>
					</div>
					<div id="siv-newAccountBtnDiv">
						<button id="siv-newAccountBtn">Create an Account</button>
					</div>
				</div>
			</div>
			
			<!-- Create Account View -->
			<div id="act-createAccountView">
				<div id="cav-title" class="shacc-header">
					Create Your Account
				</div>
				<div id="cav-emailDiv">
					<input id="cav-emailInput" class="shacc" type="text" 
						placeholder="Email" />
				</div>
				<div id="cav-passwordDiv">
					<input id="cav-passwordInput" class="shacc" type="password" 
						placeholder="Password" />
				</div>
				<div id="cav-confirmPasswordDiv">
					<input id="cav-confirmPasswordInput" class="shacc" type="password" 
						placeholder="Confirm Password" />
				</div>
				<div class="shacc-message">Name must begin with a letter and contain 
					only letters, numbers, apostrophes, hyphens or underscores.
				</div>
				<div id="cav-buttons" class="shacc-bottomButtonsSection">
					<div id="cav-createBtnDiv">
						<button id="cav-createBtn">Create</button>
					</div>
					<div id="cav-cancelBtnDiv">
						<button id="cav-cancelBtn">Cancel</button>
					</div>
				</div>
			</div>
			
			<!-- Email Confirmation View -->
			<div id="act-emailConfirmationView">
				<div id="ecv-title" class="shacc-header">Confirm Your Email</div>
				<div id="ecv-instructions">
					An email was sent to you with a link to confirm your new account.
					After completing that step, return here and click Continue. 
				</div>
				<div id="ecv-resendInstruction">If you didn't receive the email, 
					<a id="ecv-resendLink" class="shacc">click here to send it again.
					</a>
				</div>
				<div id="ecv-buttons" class="shacc-bottomButtonsSection">
					<div id="ecv-continueBtnDiv">
						<button id="ecv-continueBtn">Continue</button>
					</div>
				</div>
				<div id="ecv-signoutLinkDiv">
					<a id="ecv-signoutLink" class="shacc">Sign Out</a>
				</div>
			</div>
			
			<!-- Finish Account View -->
			<div id="act-finishAccountView">
				<div id="fav-title" class=" shacc-header">
					Complete your account.
				</div>
				<div>
					<input id="fav-usernameInput" class="shacc" type="text" 
						placeholder="Enter your username as others will see it." 
						maxlength="20"
						autocomplete="off"/>
				</div>
				<div class="shacc-message">Name must begin with a letter and contain 
					only letters and numbers.
				</div>
				<div id="fav-buttons" class="shacc-bottomButtonsSection">
					<div id="fav-finishAccountBtnDiv">
						<button id="fav-finishAccountBtn">Confirm</button>
					</div>
				</div>
				<div id="fav-signoutLinkDiv">
					<a id="fav-signoutLink" class="shacc">Sign Out</a>
				</div>
			</div>
			
			<!-- Manage Account View -->
			<div id="act-manageAccountView">
				<div id="mav-title" class="shacc-header">My Account</div>
				<div id="mav-welcome">
					Welcome, Someone!
				</div>
				<div id="mav-deleteAccountLinkDiv">
					<a id="mav-deleteAccountLink" class="shacc">Delete your account</a>
				</div>
				<div id="mav-buttons" class="shacc-bottomButtonsSection">
					<div id="mav-closeBtnDiv">
						<button id="mav-closeBtn">Return</button>
					</div>
				</div>
			</div>
		</div>
	</div>
</div>
`;